<template>
	<Modal ref="clientModal">
		<template #footer v-if="selected && !selected.checkIn">
			<div class="btn btn-success btn-block" v-ripple @click="checkIn">
				Registrar acceso al evento
			</div>
		</template>

		<div class="client p-2" v-if="selected">
			<div class="d-flex align-items-center">
				<div class="circle" :style="{ 'background-color': selected.client.profileColor }">
					<i class="icon icon-man-people-streamline-user"></i>
				</div>

				<div>
					<h3>{{ selected.client.name }} {{ selected.client.lastname }}</h3>
					<p>{{ selected.client.document }}</p>
				</div>
			</div>

			<div v-if="selected.membership" class="my-3 p-2">
				<label class="m-0"> MEMBRESIA</label>
				<h4>{{ selected.membership.membershipType.name }}</h4>
			</div>
			<div v-if="selected.ticket" class="my-3 p-2">
				<label class="m-0"> TICKET</label>

				<h4>{{ selected.ticket.ticketType.name }}</h4>
			</div>

			<div v-if="selected.checkIn" class="alert alert-dark text-center">
				Ya a ingresado al evento a las {{ selected.checkIn.createdAt | moment("HH:mm") }}
			</div>
		</div>
	</Modal>
</template>

<script>
import gql from "graphql-tag"
import Modal from "@/components/Modal"

export default {
	name: "ClientName",
	components: {
		Modal
	},
	data() {
		return {
			selected: null
		}
	},
	props: {
		eventId: {
			type: String,
			required: true
		}
	},
	methods: {
		open(selected) {
			this.selected = selected
			this.$refs.clientModal.show()
		},
		close() {
			this.selected = null
			this.$refs.clientModal.hide()
		},
		checkIn() {
			this.loading = true

			this.$apollo
				.mutate({
					mutation: gql`
						mutation($eventId: ID!, $ticketId: ID, $membershipId: ID) {
							eventCheckIn(eventId: $eventId, ticketId: $ticketId, membershipId: $membershipId)
						}
					`,
					variables: {
						eventId: this.eventId,
						ticketId: this.selected.ticket ? this.selected.ticket.id : null,
						membershipId: this.selected.membership ? this.selected.membership.id : null
					}
				})
				.then(({ data }) => {
					console.log(data)
					this.close()
					this.loading = false
				})
				.catch((error) => {
					console.log(error)
					this.loading = false
				})
		}
	}
}
</script>

<style scoped lang="scss">
.circle {
	width: 42px;
	height: 42px;
	border-radius: 24px;
	margin-right: 8px;
	display: flex;
	align-items: center;
	justify-content: center;

	.icon {
		width: 22px;
		height: 22px;
		font-size: 20px;
	}
}

h3 {
	font-size: 1rem;
	color: #fff;
	font-weight: 500;
}
h4 {
	font-size: 1.3rem;
	color: #fff;
	font-weight: 500;
}
p {
	font-size: 0.8rem;
	color: #fff;
	line-height: 0.8rem;
	margin: 0px;
}
</style>
